query ContentsListQuery(
  $page: Int
  $rowsPerPage: Int
  $filter: ContentsFilterInput
) {
  contents(page: $page, rowsPerPage: $rowsPerPage, filter: $filter) {
    count
    nodes {
      id
      title
      type
      processingStatus
      publishAt
      createdAt
      deletedAt
      preview {
        id
        url(format: SMALL)
      }
      platform {
        id
        title
      }
    }
  }
}
